import { withInstall } from '@element-plus/utils/with-install'

import Col from './src/col'

export const ElCol = withInstall(Col)
export default ElCol

export * from './src/col'
